// extracted by mini-css-extract-plugin
export default {"ferry-list":"FerryList_ferry-list__xLAM2"};